import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header/header';
import { useSelector } from 'react-redux';

const Layout = () => { 
  const { email, name, role, currency } = useSelector((state) => state.user);
  
  return (
    <div className="">
      <div className="flex-1 flex flex-col h-screen">
        <Header email={email} name={name} role={role}/>
        <main className="flex-grow p-4 bg-primary pt-20 text-white">
          <Outlet context={{ email, name, role, currency }}/>
        </main>
      </div>
    </div>
  );
};

export default Layout;
